/**
 * @file: 画布StageCore逻辑入口
 * @author: xiaolong.huang@dmall.com
 */

// import Fundebug from 'fundebug-javascript';
import * as StageStatus from './stageStatus';
import { Message, Tool, Config } from './export/index';
import CubeRegister from './cubeRegister';
import RunPreTask from './runPreTask/index';
import Storage from './storage/index';
import Paper from './paper';
import __Config__ from './config/index';

/**
 * 测试图纸名称
 *
 * shelf
 * goodsSize
 * cabinet
 * debug
 * unit
 * huge
 * beamSize
 * goodsLayout
 * drag
 * goodsDrag
 * groupRightLeft
 * groupSpaceAround
 * groupSpaceBetween
 * subDrag
 * history
 * goodsTag
 * chest
 * bafflePlateLayout
 * grid
 */
import mockData from '../mock/paper/debug.json';

// const fundebugConfig: FundebugInitConfig = __Config__.get({
//     moduleName: 'fundebug',
//     key: 'initConfig'
// });
//
// Fundebug.init(fundebugConfig);
// cube注册
CubeRegister();

function Init(params: JsonData): void {
    let paperData: JsonData = params.shelfData || mockData;

    // 运行前事务处理
    RunPreTask(paperData);

    // 本地存储初始化
    Storage.init();

    StageStatus.isTopFace() ?
        Paper.createCabinet(paperData)
        :
        Paper.createShelf(paperData);
}

export { Message, Init, Tool, Config };
